export default {
    buttons: {
        save: 'Сохранить',
    },
    fields: {
        old_password: {
            label: 'Старый пароль',
            placeholder: 'Введите текущий пароль',
        },
        new_password: {
            label: 'Новый пароль',
            placeholder: 'Минимум 6 символов',
        },
        password_repeat: {
            label: 'Повторите пароль',
            placeholder: 'Введите пароль еще раз',
        },
    },
    passwords_not_match: 'Пароли не совпадают',
}
